webpackJsonp([18,47],{

/***/ 1086:
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(946);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1087:
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1088:
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1089:
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(1086);

var iterableToArray = __webpack_require__(1087);

var unsupportedIterableToArray = __webpack_require__(1090);

var nonIterableSpread = __webpack_require__(1088);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1090:
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(946);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 1091:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['list', 'id', 'label', 'icon', 'single', 'input', 'all', 'minWidth'],
  data: function data() {
    return {
      selected: '',
      selectedList: [],
      number: 0,
      clicked: false,
      searchText: '',
      finalized: [],
      menu: false
    };
  },
  computed: {
    displayArray: function displayArray() {
      var _this = this;

      var filtered = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.filter(this.list, function (_ref) {
        var value = _ref.value;
        return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.includes(__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(value.text), __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.toLower(_this.searchText));
      });

      var arr = filtered.slice(0, 15);
      return arr;
    }
  },
  methods: {
    customFilter: function customFilter(item, queryText, itemText) {
      var hasValue = function hasValue(val) {
        return val != null ? val : '';
      };

      var text = hasValue(item.value.text);
      var query = hasValue(queryText);
      return text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1;
    },
    apply: function apply() {
      var arr = [];

      if (__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.isString(this.finalized) && !this.single) {
        arr.push(this.finalized);
      } else {
        arr = Array.isArray(this.finalized) ? __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(this.finalized) : this.finalized;
      }

      this.$emit('apply', {
        id: this.id,
        filter: arr
      });
      this.number = this.finalized.length;
      this.menu = false;
      this.clicked = true;
    }
  },
  watch: {
    menu: function menu(val) {
      if (!val) {
        this.finalized = this.input.length ? this.input : [];
        this.searchText = '';
      }
    },
    input: function input(val) {
      this.finalized = val;
    },
    selected: function selected(val) {
      if (this.single) {
        this.finalized = val;
      } else {
        if (val !== '' && val && !__WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.selectedList, function (_ref2) {
          var value = _ref2.value;
          return val === value;
        })) {
          this.selectedList = [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(this.selectedList), [val]);
          this.finalized = [].concat(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(this.finalized), [val.value]);
        }
      }
    }
  }
};

/***/ }),

/***/ 1092:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".btn[data-v-acf5c4e0]{margin:0!important}", "", {"version":3,"sources":["/home/circleci/repo/src/components/filter/multipleFilter.vue"],"names":[],"mappings":"AACA,sBACE,kBAAuB,CACxB","file":"multipleFilter.vue","sourcesContent":["\n.btn[data-v-acf5c4e0] {\n  margin: 0px !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1093:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1092);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("a73c690a", content, true, {});

/***/ }),

/***/ 1094:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1093)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1091),
  /* template */
  __webpack_require__(1095),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-acf5c4e0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1095:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    staticStyle: {
      "height": "30px",
      "width": "100%"
    },
    attrs: {
      "min-width": _vm.minWidth,
      "close-on-content-click": false,
      "offset-y": ""
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [(_vm.single) ? _c('v-btn', {
    staticStyle: {
      "font-size": "14px",
      "width": "100%"
    },
    attrs: {
      "slot": "activator",
      "depressed": "",
      "outline": "",
      "color": _vm.input !== "" ? "indigo" : "black",
      "small": "",
      "flat": ""
    },
    slot: "activator"
  }, [_vm._v("\n    " + _vm._s(_vm.label) + "\n    "), (_vm.icon) ? _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v(_vm._s(_vm.icon))]) : _vm._e()], 1) : _c('v-btn', {
    staticStyle: {
      "font-size": "14px",
      "width": "100%"
    },
    attrs: {
      "slot": "activator",
      "depressed": "",
      "outline": "",
      "color": _vm.input && _vm.input.length > 0 ? "indigo" : "black",
      "small": "",
      "flat": ""
    },
    slot: "activator"
  }, [_vm._v("\n    " + _vm._s(_vm.input && _vm.input.length > 0 ? (_vm.label + "(" + (_vm.input.length) + ")") : _vm.label) + "\n    "), (_vm.icon) ? _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v(_vm._s(_vm.icon))]) : _vm._e()], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [(!_vm.all) ? _c('v-list-tile', [(_vm.single) ? _c('v-select', {
    attrs: {
      "filter": _vm.customFilter,
      "items": _vm.list,
      "autocomplete": "",
      "dense": "",
      "clearable": "",
      "open-on-clear": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('v-list-tile-content', {
          staticStyle: {
            "margin-top": "0px"
          }
        }, [_c('v-list-tile-title', {
          staticClass: "caption",
          domProps: {
            "innerHTML": _vm._s(data.item.value.text || data.item.value)
          }
        })], 1)]
      }
    }], null, false, 2026596982),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }) : _c('v-select', {
    attrs: {
      "filter": _vm.customFilter,
      "items": _vm.list,
      "autocomplete": "",
      "dense": "",
      "clearable": "",
      "open-on-clear": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('v-list-tile-content', {
          staticStyle: {
            "margin-top": "0px"
          }
        }, [_c('v-list-tile-title', {
          staticClass: "caption",
          domProps: {
            "innerHTML": _vm._s(data.item.value.text || data.item.value)
          }
        })], 1)]
      }
    }], null, false, 2026596982),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.all && !_vm.single) ? [_c('v-list-tile', [(_vm.list.length > 15) ? _c('v-text-field', {
    attrs: {
      "row-height": "10",
      "single-line": "",
      "label": "Search"
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm._l((_vm.displayArray), function(item, index) {
    return [_c('v-list-tile', {
      key: index,
      staticStyle: {
        "margin-bottom": "-10px"
      }
    }, [_c('v-checkbox', {
      key: item.value.value,
      attrs: {
        "label": ("" + (item.value.text)),
        "value": item.value.value
      },
      model: {
        value: (_vm.finalized),
        callback: function($$v) {
          _vm.finalized = $$v
        },
        expression: "finalized"
      }
    })], 1)]
  })] : (_vm.all && _vm.single) ? [_vm._l((_vm.list), function(item, index) {
    return [_c('v-list-tile', {
      key: index
    }, [_c('v-radio-group', {
      model: {
        value: (_vm.finalized),
        callback: function($$v) {
          _vm.finalized = $$v
        },
        expression: "finalized"
      }
    }, [_c('v-radio', {
      key: item.value,
      attrs: {
        "label": ("" + (item.text)),
        "value": item.value
      }
    })], 1)], 1)]
  })] : (!_vm.single) ? _vm._l((_vm.selectedList), function(item, index) {
    return [_c('v-list-tile', {
      key: index
    }, [_c('v-checkbox', {
      key: index,
      attrs: {
        "label": ("" + (item.text)),
        "value": item.value
      },
      model: {
        value: (_vm.finalized),
        callback: function($$v) {
          _vm.finalized = $$v
        },
        expression: "finalized"
      }
    })], 1)]
  }) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.menu = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "color": "primary"
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("Apply")])], 1)], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1115:
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(1563);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 1116:
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1546);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 1117:
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(1193);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 1118:
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1538);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 1127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ShareButton_vue__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ShareButton_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ShareButton_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



__WEBPACK_IMPORTED_MODULE_3_vue___default.a.filter('formatDateTime', function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_2_moment___default()(value).format('MMMM DD, YYYY');
  }
});
/* harmony default export */ __webpack_exports__["default"] = {
  components: {
    ShareButton: __WEBPACK_IMPORTED_MODULE_1__components_ShareButton_vue___default.a
  },
  props: ['dialog', 'item'],
  data: function data() {
    return {
      openModal: false,
      favorited: false
    };
  },
  watch: {
    openModal: function openModal(val) {}
  },
  methods: {
    cancel: function cancel() {
      this.$emit('cancel');
    },
    favoriteItem: function favoriteItem() {
      var favoritePayload = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()({}, this.item.id, this.item.id);

      this.$firebase.database().ref("favorites/resources/".concat(this.user.uid, "/").concat(this.item.id)).set(favoritePayload);
    },
    unfavoriteItem: function unfavoriteItem() {
      console.log('clicked');
      this.$firebase.database().ref("favorites/resources/".concat(this.user.uid, "/").concat(this.item.id)).set(null);
    },
    isFavourited: function isFavourited() {
      var self = this;
      this.$firebase.database().ref("favorites/resources/".concat(this.user.uid, "/").concat(this.item.id)).on('value', function (snapshot) {
        if (!snapshot.val()) {
          self.favorited = false;
        } else {
          self.favorited = true;
        }
      });
    }
  },
  computed: {
    breakpoint: function breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    htmlContent: function htmlContent() {
      return this.item.content;
    },
    openDialog: function openDialog() {
      this.openModal = this.dialog;

      if (this.openModal === true) {
        this.isFavourited();
      }

      return this.dialog;
    },
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    screenWidth: function screenWidth() {
      return this.$vuetify.breakpoint.width;
    },
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    userDetails: function userDetails() {
      return this.$store.getters.getUserDetails;
    },
    shareLink: function shareLink() {
      return window.location;
    },
    link: function link() {
      return "https://".concat(window.location.host, "/resources#id=").concat(this.item.id);
    }
  }
};

/***/ }),

/***/ 1149:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".group[data-v-04e686ba]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-pack:distribute;justify-content:space-around}.tabs__wrapper[data-v-04e686ba]{overflow:hidden}.vue-highcharts[data-v-04e686ba]{border:none;-webkit-box-shadow:none;box-shadow:none}.tabs__content[data-v-04e686ba]{height:500px;overflow-x:hidden;overflow-y:scroll}.resource_post_details[data-v-04e686ba]{padding-top:220px}.resource_post_details span[data-v-04e686ba],.resource_post_details strong[data-v-04e686ba]{color:#fff;font-size:16px}.resource_content h2[data-v-04e686ba]{font-size:28px;color:#000;line-height:32px;font-weight:600}.resource_content p[data-v-04e686ba]{margin-bottom:0;font-size:18px;color:#666}.post_img[data-v-04e686ba]{height:300px;line-height:300px;width:100%;text-align:center}.post_img img[data-v-04e686ba]{max-height:300px;width:auto;display:inline-block;vertical-align:middle;line-height:normal}.post_img iframe[data-v-04e686ba]{min-height:300px;width:100%;border:none}", "", {"version":3,"sources":["/home/circleci/repo/src/components/modal/info/resourceViewModal.vue"],"names":[],"mappings":"AACA,wBACE,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AACpB,WAAY,AACZ,OAAQ,AACR,yBAA0B,AAC1B,4BAA8B,CAC/B,AACD,gCACE,eAAiB,CAClB,AACD,iCACE,YAAa,AACb,wBAAwB,AAChB,eAAgB,CACzB,AACD,gCACE,aAAc,AACd,kBAAkB,AAClB,iBAAmB,CACpB,AACD,wCACI,iBAAkB,CACrB,AACD,4FAGI,WAAW,AACX,cAAgB,CACnB,AACD,sCACI,eAAgB,AAChB,WAAY,AACZ,iBAAkB,AAClB,eAAiB,CACpB,AACD,qCACI,gBAAiB,AACjB,eAAgB,AAChB,UAAY,CACf,AACD,2BACI,aAAc,AACd,kBAAmB,AACnB,WAAY,AACZ,iBAAmB,CACtB,AACD,+BACM,iBAAkB,AAClB,WAAY,AACd,qBAAsB,AACtB,sBAAuB,AACvB,kBAAoB,CACvB,AACD,kCACI,iBAAkB,AAClB,WAAY,AACZ,WAAa,CAChB","file":"resourceViewModal.vue","sourcesContent":["\n.group[data-v-04e686ba] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  -ms-flex-pack: distribute;\n  justify-content: space-around;\n}\n.tabs__wrapper[data-v-04e686ba] {\n  overflow: hidden;\n}\n.vue-highcharts[data-v-04e686ba] {\n  border: none;\n  -webkit-box-shadow:none;\n          box-shadow:none;\n}\n.tabs__content[data-v-04e686ba] {\n  height: 500px;\n  overflow-x:hidden;\n  overflow-y: scroll;\n}\n.resource_post_details[data-v-04e686ba]{\n    padding-top:220px;\n}\n.resource_post_details strong[data-v-04e686ba],\n  .resource_post_details span[data-v-04e686ba]\n  {\n    color:#fff;\n    font-size: 16px;\n}\n.resource_content h2[data-v-04e686ba]{\n    font-size: 28px;\n    color: #000;\n    line-height: 32px;\n    font-weight: 600;\n}\n.resource_content p[data-v-04e686ba]{\n    margin-bottom: 0;\n    font-size: 18px;\n    color: #666;\n}\n.post_img[data-v-04e686ba]{\n    height: 300px;\n    line-height: 300px;\n    width: 100%;\n    text-align: center;\n}\n.post_img img[data-v-04e686ba]{\n      max-height: 300px;\n      width: auto;\n    display: inline-block;\n    vertical-align: middle;\n    line-height: normal;\n}\n.post_img iframe[data-v-04e686ba]{\n    min-height: 300px;\n    width: 100%;\n    border: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1171:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1149);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("416e0fbe", content, true, {});

/***/ }),

/***/ 1193:
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1533),
    getValue = __webpack_require__(1540);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 1198:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1171)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1127),
  /* template */
  __webpack_require__(1215),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-04e686ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1215:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "800px",
      "persistent": "",
      "transition": "scale-transition",
      "max-height": "600px"
    },
    model: {
      value: (_vm.openDialog),
      callback: function($$v) {
        _vm.openDialog = $$v
      },
      expression: "openDialog"
    }
  }, [_c('v-card', {
    staticStyle: {
      "overflow": "hidden",
      "display": "block"
    }
  }, [(_vm.item) ? _c('v-layout', {
    attrs: {
      "id": "resource-modal"
    }
  }, [_c('v-flex', {
    staticClass: "resource-main",
    staticStyle: {
      "height": "600px",
      "overflow-y": "scroll"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-layout', {
    staticClass: "secondary",
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.cancel()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "resource_content",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "resource-details-actions secondary"
  }, [_c('h2', {
    staticClass: "py-4 px-4 resource-title text-sm-center white--text"
  }, [_vm._v(_vm._s(_vm.item.title))]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "px-4": "",
      "pb-3": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "pt-1": "",
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("access_time")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("actualDate")(_vm.item.submitdate)))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "white--text",
    attrs: {
      "pt-1": "",
      "sm4": "",
      "justify-center": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("list_alt")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.category))])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "white--text",
    attrs: {
      "pt-1": "",
      "sm4": "",
      "justify-center": ""
    }
  }, [_c('v-icon', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "color": "white"
    }
  }, [_vm._v("fa-tags")]), _vm._v(" "), _vm._l((_vm.item.tags), function(tag, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(tag)), (index + 1 < _vm.item.tags.length) ? _c('span', [_vm._v(",")]) : _vm._e()])
  })], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pt-2 post_img resource-media"
  }, [(_vm.item.media.id) ? _c('iframe', {
    attrs: {
      "src": _vm.item.media.embedUrl,
      "allowfullscreen": ""
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.item.media,
      "alt": "Agency Logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "px-4 py-4 description resource-text",
    domProps: {
      "innerHTML": _vm._s(_vm.item.content)
    }
  }), _vm._v(" "), _c('v-layout', [_c('v-card-actions', {
    staticStyle: {
      "position": "relative",
      "bottom": "25px",
      "width": "100%"
    },
    attrs: {
      "dark": ""
    }
  }, [_c('v-layout', {
    staticClass: "mt-1 pt-1 mx-4 text-xs-center",
    attrs: {
      "justify-space-around": ""
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [(!_vm.favorited) ? _c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "slot": "activator",
      "small": "",
      "secondary--text": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.favoriteItem.apply(null, arguments)
      }
    },
    slot: "activator"
  }, [_c('v-layout', {
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-icon', {
    staticClass: "secondary--text",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("favorite")])], 1)], 1) : _c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "slot": "activator",
      "small": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.unfavoriteItem.apply(null, arguments)
      }
    },
    slot: "activator"
  }, [_c('v-layout', {
    staticStyle: {
      "font-size": "10px"
    },
    attrs: {
      "column": "",
      "align-center": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "medium": "",
      "color": "red"
    }
  }, [_vm._v("favorite")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('share-button', {
    attrs: {
      "color": "secondary",
      "link": _vm.link
    }
  })], 1)])], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1242:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(1118);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 1243:
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 1244:
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 1252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_filter_multipleFilter_vue__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_filter_multipleFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_filter_multipleFilter_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = {
  props: ['filterPost', 'featuredResources', 'contentType', 'category'],
  components: {
    MultipleFilter: __WEBPACK_IMPORTED_MODULE_0__components_filter_multipleFilter_vue___default.a
  },
  data: function data() {
    return {
      input: null,
      datepickermenu: false,
      datepickermenuto: false,
      datepickermenufrom: false,
      datefilter: null,
      fromdate: null,
      todate: null,
      dialog: false,
      item: null,
      counter: 9,
      width: '',
      search: '',
      filterType: '',
      filterValue: '',
      items: [],
      count: 0,
      countlength: 0
    };
  },
  methods: {
    applyFilter: function applyFilter(_ref) {
      var id = _ref.id,
          filter = _ref.filter;

      if (filter.text.indexOf('All') >= 0) {
        return this.featuredResources(9);
      }

      return this.filterPost(id, filter.text);
    },
    save: function save() {
      var self = this;
      self.items = [];
      self.resources = [];

      if (this.fromdate && this.todate) {
        this.$firebase.database().ref("resources").orderByChild("revisiondate").startAt(Date.parse(this.fromdate)).endAt(Date.parse(this.todate)).on("value", function (snap) {
          self.items = [];
          self.resources = [];
          snap.forEach(function (childSnapshot) {
            var childData = childSnapshot.val();
            self.getUserInfo(childData.uid, self.count).then(function (result) {
              self.items.push(childData);
            });
          });
          self.counter = 9;
          self.resources = self.items;
        });
      }
    },
    getUserInfo: function getUserInfo(uid, index) {
      return this.$firebase.database().ref("users/" + uid).once("value");
    }
  },
  computed: {
    contents: function contents() {
      var list = this.contentType;

      if (!list.includes('All Content Types')) {
        list.push('All Content Types');
      }

      list = list.filter(function (type) {
        return type;
      }).map(function (type) {
        return {
          text: type,
          value: {
            text: type,
            value: type
          }
        };
      });
      return list;
    },
    categories: function categories() {
      var list = this.category;

      if (!list.includes('All categories')) {
        list.push('All categories');
      }

      list = list.filter(function (type) {
        return type;
      }).map(function (type) {
        return {
          text: type,
          value: {
            text: type,
            value: type
          }
        };
      });
      return list;
    }
  }
};

/***/ }),

/***/ 1277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_info_resourceViewModal_vue__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_modal_info_resourceViewModal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_modal_info_resourceViewModal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_chat_sideboxChat_vue__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_chat_sideboxChat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_chat_sideboxChat_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mobile_ResourcesFilter_vue__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mobile_ResourcesFilter_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_mobile_ResourcesFilter_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






__WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter("formatDateTime", function (value) {
  if (value) {
    return __WEBPACK_IMPORTED_MODULE_0_moment__(value).format("MMMM DD, YYYY");
  }
});
var db = __WEBPACK_IMPORTED_MODULE_1_vue___default.a.prototype.$firebase.database();
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter("excerpt", function (value) {
  return value.substr(0, 36) + "...";
});
__WEBPACK_IMPORTED_MODULE_1_vue___default.a.filter("json", function (value) {
  return json(value);
});
/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      datepickermenu: false,
      datepickermenuto: false,
      datepickermenufrom: false,
      datefilter: null,
      fromdate: null,
      todate: null,
      dialog: false,
      item: null,
      counter: 9,
      viewMobileFilter: false,
      resources: [],
      width: '',
      sidebarScroll: function sidebarScroll() {},
      search: '',
      filterContainerResize: null,
      category: [],
      filterType: '',
      filterValue: '',
      contentType: [],
      items: [],
      count: 0,
      countlength: 0
    };
  },
  components: {
    ResourcesModal: __WEBPACK_IMPORTED_MODULE_3__components_modal_info_resourceViewModal_vue___default.a,
    SideViewChat: __WEBPACK_IMPORTED_MODULE_4__components_chat_sideboxChat_vue___default.a,
    MobileResourceFilter: __WEBPACK_IMPORTED_MODULE_5__components_mobile_ResourcesFilter_vue___default.a
  },
  firebase: function firebase() {
    return {
      getResources: db.ref("resources")
    };
  },
  watch: {
    breakpoint: function breakpoint() {}
  },
  computed: {
    breakpoint: function breakpoint() {
      return this.$vuetify.breakpoint.name;
    },
    pageData: function pageData() {
      return this.$store.getters.getSettings.pages;
    },
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    styles: function styles() {
      return this.$store.getters.getStyles;
    },
    htmlContent: function htmlContent(data) {
      return data;
    },
    sortedList: function sortedList() {
      if (this.search.length) {
        var search = this.search.toLowerCase().split(' ');
        return this.resources.filter(function (resource) {
          return search.every(function (val) {
            if (resource.title.toLowerCase().indexOf(val) > -1 || resource.content.toLowerCase().indexOf(val) > -1) {
              return true;
            } else {
              false;
            }
          });
        }).sort(function (d1, d2) {
          return new Date(d2.revisiondate).getTime() - new Date(d1.revisiondate).getTime();
        });
      }

      return this.resources.sort(function (d1, d2) {
        return new Date(d2.revisiondate).getTime() - new Date(d1.revisiondate).getTime();
      });
    }
  },
  mounted: function mounted() {
    this.sticky();
    this.onResize();
    var id = window.location.hash.substring(1);

    if (id) {
      this.getResource(id);
    }

    var payload = {
      meta: {
        h1: this.pageData.resources.header,
        title: this.pageData.resources.header,
        description: "Resources Page",
        keywords: "",
        requiresAuth: true
      }
    };
    document.title = payload.meta.title;
    this.$store.commit("setHeaderInfo", payload);
    this.getCategory();
    this.getFeaturedResources();
  },
  methods: {
    sticky: function sticky() {
      var self = this;
      var sidebar = document.querySelector('.filter_sidebar.card');

      if (sidebar) {
        var sidebarPos = sidebar.getBoundingClientRect();
        var sidebarPosTop = sidebarPos.top < 550 ? 550 : sidebarPos.top;
        var sidebarContainer = document.querySelector('.filter-sidebar-container');
        self.width = sidebarContainer.clientWidth - 16 + 'px';
        var contentAreaHeight = document.getElementById('resources-main-container').offsetHeight;
        window.addEventListener('scroll', function () {
          var windowScrollTop = document.documentElement.scrollTop;

          if (windowScrollTop <= sidebarPosTop) {
            sidebar.className = sidebar.className.replace('sticky', '').trim();
          } // Scroll is past the original position of sidebar
          else if (windowScrollTop >= sidebarPosTop) {
            // Otherwise add the sticky if sidebar doesnt have it already!
            if (sidebar.className.indexOf('sticky') <= -1) {
              sidebar.className += ' sticky';
            }
          }
        });
      }
    },
    onResize: function onResize() {
      var self = this;
      var sidebarContainer = document.querySelector('.filter-sidebar-container');
      var watchResize = new window.WatchElementResize(sidebarContainer);
      watchResize.on('resize', function (event) {
        self.width = event.element.offset.width - 16 + 'px';
      });
    },
    closeModal: function closeModal() {
      this.dialog = false;
    },
    cancel: function cancel() {
      window.location.hash = '';
      this.dialog = false;
    },
    getCategory: function getCategory() {
      var self = this;
      self.category = [];
      self.contentType = [];
      self.countlength = 0;
      this.$firebase.database().ref("resources").on("value", function (snap) {
        snap.forEach(function (childSnapshot) {
          var childData = childSnapshot.val();
          self.countlength++;
          self.category.indexOf(childData["category"]) === -1 ? self.category.push(childData["category"]) : "";
          self.category = self.category.sort(function (a, b) {
            if (a < b) return 1;
            if (b < a) return -1;
            return 0;
          });
          self.contentType.indexOf(childData["contenttype"]) === -1 ? self.contentType.push(childData["contenttype"]) : "";
        });
      });
    },
    getFeaturedResources: function getFeaturedResources() {
      var self = this;
      this.$firebase.database().ref("resources").orderByChild("revisiondate").on("value", function (snap) {
        self.items = [];
        snap.forEach(function (childSnapshot) {
          var childData = childSnapshot.val();
          if (!childData.featured) return;
          self.getUserInfo(childData.uid, self.count).then(function (result) {
            self.items.push(childData);
          });
        });
        self.resources = self.items.sort(function (d1, d2) {
          return new Date(d2.revisiondate).getTime() - new Date(d1.revisiondate).getTime();
        });
      });
    },
    save: function save() {
      var self = this;
      self.items = [];
      self.resources = [];

      if (this.fromdate && this.todate) {
        this.$firebase.database().ref("resources").orderByChild("revisiondate").startAt(Date.parse(this.fromdate)).endAt(Date.parse(this.todate)).on("value", function (snap) {
          self.items = [];
          self.resources = [];
          snap.forEach(function (childSnapshot) {
            var childData = childSnapshot.val();
            if (!childData.featured) return;
            self.getUserInfo(childData.uid, self.count).then(function (result) {
              self.items.push(childData);
            });
          });
          self.counter = 9;
          self.resources = self.items;
        });
      }
    },
    excerptDescs: function excerptDescs(v) {
      return v.substr(0, 80) + " ...";
    },
    viewEvent: function viewEvent(val) {
      this.eventData = val;
      this.eventModal = true;
      this.selected = true;
    },
    eventClick: function eventClick(event, jsEvent, pos) {
      this.viewEvent(event);
    },
    openModal: function openModal() {
      this.dialog = true;
    },
    closeViewEvent: function closeViewEvent() {
      this.eventModal = false;
      this.selected = false;
    },
    viewResource: function viewResource(item) {
      window.location.hash = "#id=".concat(item.id);
      this.dialog = true;
      this.item = item;
    },
    counterPost: function counterPost(length) {
      this.counter = this.counter + 9;
    },
    filterPost: function filterPost(type, value) {
      var self = this;
      this.filterValue = value;
      this.filterType = type;
      this.filteredResources(type, value);
    },
    filteredResources: function filteredResources(col, filter) {
      var self = this;
      this.$firebase.database().ref("resources").orderByChild(col).equalTo(filter).on("value", function (snap) {
        self.items = [];
        self.resources = [];
        snap.forEach(function (childSnapshot) {
          var childData = childSnapshot.val();
          self.getUserInfo(childData.uid, self.count).then(function (result) {
            self.items.push(childData);
          });
        });
        self.counter = 9;
        self.resources = self.items;
      });
    },
    featuredResources: function featuredResources(counter) {
      var self = this;
      self.items = [];
      this.$firebase.database().ref("resources").orderByChild("revisiondate").on("value", function (snap) {
        snap.forEach(function (childSnapshot) {
          var childData = childSnapshot.val();
          self.getUserInfo(childData.uid, self.count).then(function (result) {
            self.items.push(childData);
            self.counter = 9;
            self.resources = self.items.sort(function (d1, d2) {
              return new Date(d2.revisiondate).getTime() - new Date(d1.revisiondate).getTime();
            });
          });
        });
      });
    },
    getResource: function getResource(id) {
      var _this = this;

      var self = this;
      return this.$firebase.database().ref("resources/".concat(id.split('=')[1])).once('value', function (resourceSnap) {
        var resource = Object.assign({}, resourceSnap.val());
        return self.getUserInfo(resource.uid).then(function (userSnap) {
          resource.user = userSnap.val();
          return _this.viewResource(resource);
        });
      });
    },
    getUserInfo: function getUserInfo(uid, index) {
      return this.$firebase.database().ref("users/" + uid).once("value");
    },
    getCompanyInformation: function getCompanyInformation(cid, index) {
      return this.$firebase.database().ref("companies/" + cid).once("value");
    }
  }
};

/***/ }),

/***/ 1363:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".flex-list{padding:4px}.flex-list .input-group__details{min-height:0}.flex-list .menu{margin-left:0}", "", {"version":3,"sources":["/home/circleci/repo/src/components/mobile/ResourcesFilter.vue"],"names":[],"mappings":"AACA,WACE,WAAa,CACd,AACD,iCACE,YAAgB,CACjB,AACD,iBACE,aAAiB,CAClB","file":"ResourcesFilter.vue","sourcesContent":["\n.flex-list {\n  padding: 4px;\n}\n.flex-list .input-group__details {\n  min-height: 0px;\n}\n.flex-list .menu {\n  margin-left: 0px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1402:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".filter_sidebar.card.sticky{position:fixed;top:68px}.date_btn{margin:0}.date_range .menu{width:40%;vertical-align:middle;display:block!important;margin-right:20px;margin-left:0;float:left}.card_img{text-align:center;background-size:cover;background-position:50%}.card_img,.card_img img{width:100%;height:180px}.resource_card{min-height:360px;cursor:pointer}.resource_card .resource_content{padding:10px 15px}.resource_card .resource-title{font-size:16px;line-height:18px;color:#413127;font-weight:600}.resource_card .resource-date{font-size:11px;color:#999}.resource_card .description,.resource_card .description>p>strong{font-size:14px;line-height:19px;color:#777;font-weight:400!important}.search_field i{width:25px;display:inline-block;vertical-align:middle}.search_field .input-group{width:calc(100% - 70px);display:inline-block;vertical-align:middle}.filter_sidebar h3{font-size:23px;font-weight:600}.filter_sidebar h4{font-size:16px}.filter_sidebar ul{margin:10px 0 30px;list-style:none;padding:0}.filter_sidebar ul li{margin:10px 0}.filter_sidebar ul li a{color:#888;text-decoration:none}", "", {"version":3,"sources":["/home/circleci/repo/src/pages/ResourcesView.vue"],"names":[],"mappings":"AACA,4BACE,eAAgB,AAChB,QAAU,CACX,AACD,UACI,QAAS,CACZ,AACD,kBACA,UAAW,AACP,sBAAuB,AACvB,wBAA0B,AAC1B,kBAAmB,AACnB,cAAiB,AACjB,UAAY,CACf,AACD,UAGI,kBAAmB,AACnB,sBAAsB,AACtB,uBAAkC,CACrC,AACD,wBANI,WAAW,AACX,YAAa,CAQhB,AACD,eACE,iBAAkB,AAClB,cAAgB,CACjB,AACD,iCACE,iBAAmB,CACpB,AACD,+BACE,eAAgB,AAChB,iBAAkB,AAClB,cAAe,AACf,eAAiB,CAClB,AACD,8BACE,eAAgB,AAChB,UAAY,CACb,AACD,iEAEE,eAAgB,AAChB,iBAAkB,AAClB,WAAY,AACZ,yBAA4B,CAC7B,AACD,gBACE,WAAY,AACZ,qBAAsB,AACtB,qBAAuB,CACxB,AACD,2BACE,wBAAyB,AACzB,qBAAsB,AACtB,qBAAuB,CACxB,AACD,mBACE,eAAgB,AAChB,eAAiB,CAClB,AACD,mBACE,cAAgB,CACjB,AACD,mBACE,mBAAoB,AACpB,gBAAiB,AACjB,SAAW,CACZ,AACD,sBACE,aAAe,CAChB,AACD,wBACE,WAAY,AACZ,oBAAsB,CACvB","file":"ResourcesView.vue","sourcesContent":["\n.filter_sidebar.card.sticky {\n  position: fixed;\n  top: 68px;\n}\n.date_btn{\n    margin:0;\n}\n.date_range .menu{\nwidth: 40%;\n    vertical-align: middle;\n    display: block !important;\n    margin-right: 20px;\n    margin-left: 0px;\n    float: left;\n}\n.card_img{\n    width:100%;\n    height:180px;\n    text-align: center;\n    background-size:cover;\n    background-position:center center;\n}\n.card_img img{\n    width: 100%;\n    height:180px;\n}\n.resource_card {\n  min-height: 360px;\n  cursor: pointer;\n}\n.resource_card .resource_content {\n  padding: 10px 15px;\n}\n.resource_card .resource-title {\n  font-size: 16px;\n  line-height: 18px;\n  color: #413127;\n  font-weight: 600;\n}\n.resource_card .resource-date {\n  font-size: 11px;\n  color: #999;\n}\n.resource_card .description,\n.resource_card .description > p > strong {\n  font-size: 14px;\n  line-height: 19px;\n  color: #777;\n  font-weight: 400 !important;\n}\n.search_field i {\n  width: 25px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.search_field .input-group {\n  width: calc(100% - 70px);\n  display: inline-block;\n  vertical-align: middle;\n}\n.filter_sidebar h3 {\n  font-size: 23px;\n  font-weight: 600;\n}\n.filter_sidebar h4 {\n  font-size: 16px;\n}\n.filter_sidebar ul {\n  margin: 10px 0 30px;\n  list-style: none;\n  padding: 0;\n}\n.filter_sidebar ul li {\n  margin: 10px 0;\n}\n.filter_sidebar ul li a {\n  color: #888;\n  text-decoration: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1363);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("7130c99a", content, true, {});

/***/ }),

/***/ 1491:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1402);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("00f5d5cb", content, true, {});

/***/ }),

/***/ 1521:
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1541),
    hashDelete = __webpack_require__(1542),
    hashGet = __webpack_require__(1543),
    hashHas = __webpack_require__(1544),
    hashSet = __webpack_require__(1545);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 1522:
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1548),
    listCacheDelete = __webpack_require__(1549),
    listCacheGet = __webpack_require__(1550),
    listCacheHas = __webpack_require__(1551),
    listCacheSet = __webpack_require__(1552);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 1523:
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(1193),
    root = __webpack_require__(1118);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 1524:
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1553),
    mapCacheDelete = __webpack_require__(1554),
    mapCacheGet = __webpack_require__(1555),
    mapCacheHas = __webpack_require__(1556),
    mapCacheSet = __webpack_require__(1557);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 1525:
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(1193),
    root = __webpack_require__(1118);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 1526:
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(1524),
    setCacheAdd = __webpack_require__(1559),
    setCacheHas = __webpack_require__(1560);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 1527:
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1531);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 1528:
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 1529:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 1530:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(1242),
    getRawTag = __webpack_require__(1539),
    objectToString = __webpack_require__(1558);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 1531:
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(1529),
    baseIsNaN = __webpack_require__(1532),
    strictIndexOf = __webpack_require__(1561);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 1532:
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 1533:
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(1564),
    isMasked = __webpack_require__(1547),
    isObject = __webpack_require__(1244),
    toSource = __webpack_require__(1562);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 1534:
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(1526),
    arrayIncludes = __webpack_require__(1527),
    arrayIncludesWith = __webpack_require__(1528),
    cacheHas = __webpack_require__(1535),
    createSet = __webpack_require__(1537),
    setToArray = __webpack_require__(1243);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 1535:
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 1536:
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(1118);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 1537:
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(1525),
    noop = __webpack_require__(1565),
    setToArray = __webpack_require__(1243);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 1538:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(39)))

/***/ }),

/***/ 1539:
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(1242);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 1540:
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 1541:
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1117);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 1542:
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 1543:
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1117);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 1544:
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1117);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 1545:
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(1117);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 1546:
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 1547:
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1536);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 1548:
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 1549:
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(1115);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 1550:
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(1115);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 1551:
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(1115);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 1552:
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(1115);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 1553:
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1521),
    ListCache = __webpack_require__(1522),
    Map = __webpack_require__(1523);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 1554:
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(1116);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 1555:
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(1116);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 1556:
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(1116);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 1557:
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(1116);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 1558:
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 1559:
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 1560:
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 1561:
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 1562:
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 1563:
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 1564:
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(1530),
    isObject = __webpack_require__(1244);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 1565:
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 1566:
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(1534);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),

/***/ 1581:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1452)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1252),
  /* template */
  __webpack_require__(1653),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1653:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "ml-3 mobile-filter-sidebar-container"
  }, [_c('v-card', {
    staticClass: "filter_sidebar",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "color": "white px-2 py-2"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "flex-list",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.datepickermenufrom),
      callback: function($$v) {
        _vm.datepickermenufrom = $$v
      },
      expression: "datepickermenufrom"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "slot": "activator",
      "required": "",
      "placeholder": "From",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  }, [
    [_c('v-card-actions', [_c('v-btn', {
      attrs: {
        "flat": "",
        "primary": ""
      },
      on: {
        "click": function($event) {
          _vm.datepickermenufrom = false
        }
      }
    }, [_vm._v("OK")])], 1)]
  ], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "flex-list",
    attrs: {
      "xs6": ""
    }
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.datepickermenuto),
      callback: function($$v) {
        _vm.datepickermenuto = $$v
      },
      expression: "datepickermenuto"
    }
  }, [_c('v-text-field', {
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "slot": "activator",
      "required": "",
      "placeholder": "To",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  }, [
    [_c('v-card-actions', [_c('v-btn', {
      attrs: {
        "flat": "",
        "primary": ""
      },
      on: {
        "click": function($event) {
          _vm.datepickermenuto = false
        }
      }
    }, [_vm._v("OK")])], 1)]
  ], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "flex-list",
    attrs: {
      "xs6": ""
    }
  }, [_c('multiple-filter', {
    attrs: {
      "single": true,
      "all": true,
      "list": _vm.contents,
      "id": "contenttype",
      "label": "Content Type",
      "input": ''
    },
    on: {
      "apply": _vm.applyFilter
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "flex-list",
    attrs: {
      "xs6": ""
    }
  }, [_c('multiple-filter', {
    attrs: {
      "single": true,
      "all": true,
      "list": _vm.categories,
      "id": "category",
      "label": "Category",
      "input": ''
    },
    on: {
      "apply": _vm.applyFilter
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-btn', {
    staticClass: "date_btn mt-2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Filter")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1701:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-container', {
    staticClass: "mt-3 resources-view",
    staticStyle: {
      "padding-top": "60px",
      "max-width": "1442px",
      "position": "relative"
    }
  }, [(_vm.pageData && _vm.pageData.resources) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('p', {
    staticClass: "page-header",
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "29px",
      "font-weight": "bolder",
      "text-justify": "auto"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.pageData.resources.header))])]), _vm._v(" "), _c('v-flex', {
    staticClass: "page-subtitle",
    staticStyle: {
      "color": "#4a4a4a",
      "font-size": "18px",
      "font-weight": "400",
      "margin": "0px"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "-10px",
      "padding-top": "0px"
    }
  }, [_c('p', {
    staticStyle: {
      "text-justify": "auto",
      "line-height": "22px"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.pageData.resources.sub_text) + "\n          ")])])])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    staticClass: "search_field",
    attrs: {
      "xs9": "",
      "md4": ""
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("\n          search\n        ")]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "input-3",
      "placeholder": "Type to search"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "hidden-md-and-up": ""
    }
  }, [_c('v-btn', {
    staticClass: "right",
    staticStyle: {
      "margin-top": "14px",
      "text-transform": "capitalize"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.viewMobileFilter = !_vm.viewMobileFilter
      }
    }
  }, [_vm._v("\n          Filter\n        ")])], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": _vm.breakpoint === 'xs' || _vm.breakpoint === 'sm',
      "id": "resources-main-container"
    }
  }, [_c('v-flex', {
    staticClass: "filter-sidebar-container hidden-sm-and-down",
    attrs: {
      "xs12": "",
      "md3": ""
    }
  }, [_c('v-card', {
    staticClass: "filter_sidebar",
    style: ({
      width: _vm.width
    }),
    attrs: {
      "color": "white px-3 py-4"
    }
  }, [_c('h3', {
    staticClass: "secondary--text"
  }, [_vm._v("Content Type")]), _vm._v(" "), _c('h4', {
    staticClass: "secondary--text",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.featuredResources(9)
      }
    }
  }, [_vm._v("All content")]), _vm._v(" "), _c('ul', _vm._l((_vm.contentType), function(t, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.filterPost('contenttype', t)
        }
      }
    }, [_vm._v(_vm._s(t))])])
  }), 0), _vm._v(" "), _c('h3', {
    staticClass: "secondary--text"
  }, [_vm._v("Category")]), _vm._v(" "), _c('h4', {
    staticClass: "secondary--text",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.featuredResources(9)
      }
    }
  }, [_vm._v("All categories")]), _vm._v(" "), _c('ul', _vm._l((_vm.category), function(c, index) {
    return _c('li', {
      key: index
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.filterPost('category', c)
        }
      }
    }, [_vm._v(_vm._s(c))])])
  }), 0), _vm._v(" "), _c('h3', {
    staticClass: "secondary--text"
  }, [_vm._v("Date Posted")]), _vm._v(" "), _c('div', {
    staticClass: "date_range"
  }, [_c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.datepickermenufrom),
      callback: function($$v) {
        _vm.datepickermenufrom = $$v
      },
      expression: "datepickermenufrom"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "From",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.fromdate),
      callback: function($$v) {
        _vm.fromdate = $$v
      },
      expression: "fromdate"
    }
  }, [
    [_c('v-card-actions', [_c('v-btn', {
      attrs: {
        "flat": "",
        "primary": ""
      },
      on: {
        "click": function($event) {
          _vm.datepickermenufrom = false
        }
      }
    }, [_vm._v("OK")])], 1)]
  ], 2)], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px"
    },
    model: {
      value: (_vm.datepickermenuto),
      callback: function($$v) {
        _vm.datepickermenuto = $$v
      },
      expression: "datepickermenuto"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "required": "",
      "label": "To",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "no-title": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.todate),
      callback: function($$v) {
        _vm.todate = $$v
      },
      expression: "todate"
    }
  }, [
    [_c('v-card-actions', [_c('v-btn', {
      attrs: {
        "flat": "",
        "primary": ""
      },
      on: {
        "click": function($event) {
          _vm.datepickermenuto = false
        }
      }
    }, [_vm._v("OK")])], 1)]
  ], 2)], 1)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "date_btn",
    attrs: {
      "flat": "",
      "primary": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Filter")])], 1)], 1), _vm._v(" "), (_vm.viewMobileFilter) ? _c('mobile-resource-filter', {
    staticClass: "hidden-md-and-up",
    attrs: {
      "hidden-md-and-up": "",
      "filterPost": _vm.filterPost,
      "featuredResources": _vm.featuredResources,
      "contentType": _vm.contentType,
      "category": _vm.category
    }
  }) : _vm._e(), _vm._v(" "), _c('v-flex', {
    staticClass: "px-2",
    attrs: {
      "xs12": _vm.breakpoint === 'xs',
      "sm12": _vm.breakpoint === 'sm',
      "md9": _vm.breakpoint === 'md' || _vm.breakpoint === 'lg' || _vm.breakpoint === 'xl'
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.sortedList), function(n, index) {
    return ((index + 1) <= _vm.counter) ? _c('v-flex', {
      key: n.id,
      attrs: {
        "xs12": _vm.breakpoint === 'xs',
        "xs6": _vm.breakpoint === 'sm',
        "xs4": _vm.breakpoint === 'md' || _vm.breakpoint === 'lg' || _vm.breakpoint === 'xl',
        "px-2": "",
        "py-2": ""
      },
      on: {
        "click": function($event) {
          return _vm.viewResource(n)
        }
      }
    }, [_c('v-card', {
      staticClass: "resource_card"
    }, [_c('div', {
      staticClass: "card_img"
    }, [(n.media.id) ? _c('iframe', {
      staticStyle: {
        "width": "100%",
        "height": "180px",
        "border": "none"
      },
      attrs: {
        "src": n.media.embedUrl,
        "allowfullscreen": ""
      }
    }) : _c('img', {
      staticStyle: {
        "width": "100%",
        "height": "180px"
      },
      attrs: {
        "src": n.media
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "resource_content"
    }, [_c('span', {
      staticClass: "resource-title secondary--text"
    }, [_vm._v("\n                  " + _vm._s(n.title) + "\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "resource-date"
    }, [_vm._v("\n\n                  " + _vm._s(_vm._f("actualDate")(n.revisiondate)) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "description",
      domProps: {
        "innerHTML": _vm._s(_vm.excerptDescs(n.content))
      }
    })])])], 1) : _vm._e()
  }), 1), _vm._v(" "), _c('v-flex', {
    staticClass: "load-data-div",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [(_vm.sortedList.length > _vm.counter) ? _c('button', {
    staticClass: "btn btn--raised btn--round theme--dark primary load-more",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.counterPost(_vm.countlength)
      }
    }
  }, [_vm._v("Load More")]) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('resources-modal', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "dialog": _vm.dialog,
      "item": _vm.item
    },
    on: {
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }), _vm._v(" "), (_vm.user.uid) ? _c('side-view-chat') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 794:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1491)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(1277),
  /* template */
  __webpack_require__(1701),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 830:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(833)
}
var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(831),
  /* template */
  __webpack_require__(834),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator__);


function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ __webpack_exports__["default"] = {
  data: function data() {
    return {
      show: false,
      unread: 0,
      contacts: []
    };
  },
  computed: {
    user: function user() {
      return this.$store.getters.getUserDetails;
    },
    privileges: function privileges() {
      return this.$store.getters.getUserPrivileges;
    }
  },
  methods: {
    openChat: function openChat() {
      window.$applozic('#mck-sidebox').mckModal('show');
      window.$applozic.fn.applozic('loadTab', '');
      window.$('html').addClass('sidebox-open');
      this.setDefaultContacts();
    },
    setDefaultContacts: function setDefaultContacts() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.mark(function _callee() {
        var self, contactSnap, contacts, users, parentNode, noConversationNode, mckInner, nodes, fragment;
        return __WEBPACK_IMPORTED_MODULE_1__babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;
                _context.next = 3;
                return _this.$firebase.database().ref('default_chat_contact').once('value');

              case 3:
                contactSnap = _context.sent;
                contacts = contactSnap.val() || [];
                users = _this.$store.getters.fetchUsers;
                parentNode = document.getElementById('mck-contact-list');
                noConversationNode = document.getElementById('mck-no-conversations');
                mckInner = document.querySelector('#mck-message-cell .mck-message-inner');
                nodes = contacts.reduce(function (d, contact) {
                  var user = users.find(function (user) {
                    return user.uid === contact.uid;
                  }); // check if already exist

                  if (user) {
                    var contactExist = document.getElementById("li-user-".concat(user.uid));
                    if (contactExist) return d + '';
                    var node = self.getNode(user);
                    return d + node;
                  }

                  return d;
                }, '');
                fragment = document.createRange().createContextualFragment(nodes);

                if (!parentNode) {
                  mckInner.innerHTML = '<ul id="mck-contact-list" class="mck-contact-list mck-nav mck-nav-tabs mck-nav-stacked">';
                  parentNode = document.getElementById('mck-contact-list');
                }

                if (noConversationNode) {
                  setTimeout(function () {
                    noConversationNode.classList.remove('vis');
                    noConversationNode.classList.add('n-vis');
                  }, 800);
                }

                parentNode.prepend(fragment);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getNode: function getNode(user) {
      var avatar = user.avatar.indexOf('http') >= 0 ? user.avatar : "".concat(window.location.protocol, "//").concat(window.location.host).concat(user.avatar);
      var fullName = "".concat(user.firstname, " ").concat(user.lastname);
      return "\n      <li id=\"li-user-".concat(user.uid, "\" class=\"li-user-").concat(user.uid, " ").concat(user.uid, "\"\n        data-msg-time=\"1539049156786\"><a class=\"applozic-launcher\" href=\"#\" target=\"_self\" data-mck-conversationid=\"\"\n          data-mck-id=\"").concat(user.uid, "\" data-mck-clientgroupid=\"\" data-isgroup=\"false\">\n          <div class=\"mck-row\" title=\"").concat(fullName, "\">\n            <div class=\"mck-conversation-topic mck-truncate n-vis\"></div>\n            <div class=\"blk-lg-3\"><img src=\"").concat(avatar, "\"></div>\n            <div class=\"blk-lg-9\">\n              <div class=\"mck-row\">\n                <div class=\"blk-lg-8 mck-cont-name mck-truncate\">\n                  <div class=\"mck-ol-status n-vis\"><span class=\"mck-ol-icon\" title=\"Online\"></span>&nbsp;</div><strong>").concat(fullName, "</strong>\n                </div>\n                <div class=\"mck-text-muted move-right mck-cont-msg-date mck-truncate blk-lg-4\"></div>\n              </div>\n              <div class=\"mck-row\">\n                <div class=\"mck-cont-msg-wrapper blk-lg-6 mck-truncate msgTextExpr\">\n                  <p>Hello, how can I help you?</p>\n                </div>\n                <div class=\"mck-unread-count-box move-right mck-truncate n-vis\"><span class=\"mck-unread-count-text\">0</span></div>\n              </div>\n            </div>\n          </div>\n        </a>\n      </li>\n    ");
    }
  },
  beforeDestroy: function beforeDestroy() {
    var chatTotalUnreadCountId = Number(localStorage.getItem('chatTotalUnreadCountId'));
    window.clearInterval(chatTotalUnreadCountId);
    localStorage.removeItem('chatTotalUnreadCountId');
  },
  mounted: function mounted() {
    var _this2 = this;

    var self = this;
    var path = this.$route.path;
    this.$store.dispatch('loadUsers');
    if (!['/user/feed', '/contractors'].includes(path)) return;
    window.$applozic && window.$applozic.fn.applozic({
      appId: 'tsvcommunityxchange3b1149dc15a',
      userId: this.user.uid,
      userName: "".concat(this.user.firstname, "-").concat(this.user.lastname),
      imageLink: this.user.avatar,
      email: this.user.email,
      labels: {
        'last.seen.on': 'Last seen'
      },
      contactNumber: '',
      desktopNotification: true,
      source: '1',
      group: false,
      video: true,
      voice: true,
      notificationIconLink: 'https://www.applozic.com/favicon.ico',
      authenticationTypeId: 1,
      accessToken: '',
      locShare: false,
      // googleApiKey: "AIzaSyDKfWHzu9X7Z2hByeW4RRFJrD9SizOzZt4",
      googleApiKey: 'AIzaSyBCkHJdW4ChFLJ8cqJghc-LlhVU_FAl5G0',
      googleMapScriptLoaded: true,
      // mapStaticAPIkey: "AIzaSyCWRScTDtbt8tlXDr6hiceCsU83aS2UuZw",
      autoTypeSearchEnabled: true,
      loadOwnContacts: true,
      olStatus: true,
      onInit: function onInit(response) {
        if (response === 'success') {
          // calling function load contacts
          // const contactsJSON = self.$store.getters.fetchUsers
          //   .filter(val => val.id !== self.user.id)
          //   .map(user => {
          //     return {
          //       userId: user.id,
          //       displayName: `${user.firstname} ${user.lastname}`,
          //       imageLink:
          //         user.avatar.indexOf("http") < 0
          //           ? `${window.location.protocol}//${window.location.host}${
          //               user.avatar
          //             }`
          //           : user.avatar
          //     };
          //   });
          // self.contacts = contactsJSON;
          // $applozic.fn.applozic("loadContacts", { contacts: contactsJSON });
          // var startNew = document.getElementById('mck-msg-new')
          // startNew.addEventListener("mousemove", () => {
          //   $applozic.fn.applozic("loadContacts", { contacts: self.contacts });
          // });
          var closeButton = document.querySelector('.mck-box-close.mck-close-sidebox');
          closeButton.addEventListener('click', function () {
            window.$('html').removeClass('sidebox-open');
          });
          var chatTotalUnreadCountIntervalId = setInterval(function () {
            window.$applozic.fn.applozic('getUserDetail', {
              callback: function callback(response) {
                if (response.status === 'success') {
                  self.unread = response.data.totalUnreadCount;
                }
              }
            });
          }, 3000);
          window.localStorage.setItem('chatTotalUnreadCountId', chatTotalUnreadCountIntervalId);

          _this2.setDefaultContacts(); // watch for back icon click


          var backIconNodes = document.querySelectorAll('.mck-tab-link a.mck-conversation-tab-link');

          var _iterator = _createForOfIteratorHelper(backIconNodes),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var node = _step.value;
              node.addEventListener('click', function () {
                self.setDefaultContacts();
              });
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } else {// error in user login/register (you can hide chat button or refresh page)
        }
      },
      onTabClicked: function onTabClicked(response) {},
      contactDisplayName: function contactDisplayName(userId) {
        var users = self.$store.getters.fetchUsers;
        var contactUser = users.find(function (user) {
          return user.uid === userId;
        });

        if (contactUser) {
          return "".concat(contactUser.firstname, " ").concat(contactUser.lastname);
        }
      },
      contactDisplayImage: function contactDisplayImage(userId) {
        var users = self.$store.getters.fetchUsers;
        var contactUser = users.find(function (user) {
          return user.uid === userId;
        });

        if (contactUser) {
          return contactUser.avatar.indexOf('http') < 0 ? "".concat(window.location.protocol, "//").concat(window.location.host).concat(contactUser.avatar) : contactUser.avatar;
        }
      }
    });
  }
};

/***/ }),

/***/ 832:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(771)(true);
// imports


// module
exports.push([module.i, ".sidebox-open{overflow:hidden!important}.chatbutton{width:66px;height:66px}#mck-contact-search-list{display:none!important}.mck-box input{line-height:inherit!important}.mck-box input::-webkit-input-placeholder{line-height:inherit!important}.mck-box input::-moz-placeholder{line-height:inherit!important}.mck-box input::-ms-input-placeholder{line-height:inherit!important}.mck-box input::placeholder{line-height:inherit!important}.mck-sidebox.fade.in{width:100%!important}.mck-alpha-contact-image img{width:43px!important;height:43px!important}.row.mck-vid-overlay-footer.mck-flex-footer{margin:0!important}.mck-vid-scr-controls{width:100%!important;display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important;-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important}.row.mck-vid-overlay-header{padding-top:20px!important}.mck-vid-icon span{color:#fff!important}.mck-videocall-image{width:50px!important;height:50px!important;border-radius:100%!important}.footer-controls{width:auto!important;float:none!important;margin:0!important}.mck-contact-list .blk-lg-8{width:calc(100% - 55px)!important}.mck-running-on.vis{display:none!important}.mck-msg-box{min-height:0!important;font-size:15px!important;display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important;-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important;-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important;padding:16px 14px 10px!important}.applozic-vid-container{width:100%!important;padding:0!important;max-width:none!important}#mck-sidebox-launcher,.mck-sidebox-launcher{display:none!important}#mck-vid-icon{color:#fff!important;position:relative}#mck-vid-icon span{width:150px;display:block;position:absolute;left:-43px}.mck-vid-overlay-footer{margin-left:0!important}.mck-vid-scr-controls .footer-controls,.mck-vid-scr-controls .footer-controls button{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.mck-vid-scr-controls .footer-controls button{-webkit-box-align:center!important;-ms-flex-align:center!important;align-items:center!important;-webkit-box-pack:center!important;-ms-flex-pack:center!important;justify-content:center!important;margin:4px!important}#mck-microfone-mute-btn{border-radius:50%;height:56px!important;width:56px!important}.unread{position:absolute!important;z-index:99999!important;color:#fff!important;font-size:12px!important;font-weight:700!important;background:red!important;top:0!important;right:0!important;height:20px!important;width:20px!important;border-radius:50%!important;-webkit-transform:rotate(0deg)!important;transform:rotate(0deg)!important;opacity:1!important;left:auto!important}", "", {"version":3,"sources":["/home/circleci/repo/src/components/chat/sideboxChat.vue"],"names":[],"mappings":"AACA,cACE,yBAA4B,CAC7B,AACD,YACE,WAAY,AACZ,WAAa,CACd,AACD,yBACE,sBAAyB,CAC1B,AACD,eACE,6BAAgC,CACjC,AACD,0CACE,6BAAgC,CACjC,AACD,iCACE,6BAAgC,CACjC,AACD,sCACE,6BAAgC,CACjC,AACD,4BACE,6BAAgC,CACjC,AACD,qBACE,oBAAuB,CACxB,AACD,6BACE,qBAAuB,AACvB,qBAAwB,CACzB,AACD,4CACE,kBAAqB,CACtB,AACD,sBACE,qBAAuB,AACvB,8BAAgC,AAChC,8BAAgC,AAChC,uBAAyB,AACzB,mCAAqC,AACjC,gCAAkC,AAC9B,6BAA+B,AACvC,kCAAoC,AAChC,+BAAiC,AAC7B,gCAAmC,CAC5C,AACD,4BACE,0BAA6B,CAC9B,AACD,mBACE,oBAAuB,CACxB,AACD,qBACE,qBAAuB,AACvB,sBAAwB,AACxB,4BAA+B,CAChC,AACD,iBACE,qBAAuB,AACvB,qBAAuB,AACvB,kBAAqB,CACtB,AACD,4BACE,iCAAoC,CACrC,AACD,oBACE,sBAAyB,CAC1B,AACD,aACE,uBAA2B,AAC3B,yBAA2B,AAC3B,8BAAgC,AAChC,8BAAgC,AAChC,uBAAyB,AACzB,kCAAoC,AAChC,+BAAiC,AAC7B,iCAAmC,AAC3C,mCAAqC,AACjC,gCAAkC,AAC9B,6BAA+B,AACvC,gCAAwC,CACzC,AACD,wBACE,qBAAuB,AACvB,oBAAwB,AACxB,wBAA2B,CAC5B,AAID,4CACE,sBAAyB,CAC1B,AACD,cACE,qBAAuB,AACvB,iBAAmB,CACpB,AACD,mBACE,YAAa,AACb,cAAe,AACf,kBAAmB,AACnB,UAAY,CACb,AACD,wBACE,uBAA4B,CAC7B,AAMD,qFAJE,8BAAgC,AAChC,8BAAgC,AAChC,sBAAyB,CAa1B,AAXD,8CAIE,mCAAqC,AACjC,gCAAkC,AAC9B,6BAA+B,AACvC,kCAAoC,AAChC,+BAAiC,AAC7B,iCAAmC,AAC3C,oBAAuB,CACxB,AACD,wBACE,kBAAmB,AACnB,sBAAwB,AACxB,oBAAuB,CACxB,AACD,QACE,4BAA8B,AAC9B,wBAA0B,AAC1B,qBAAuB,AACvB,yBAA2B,AAC3B,0BAA4B,AAC5B,yBAA2B,AAC3B,gBAAoB,AACpB,kBAAsB,AACtB,sBAAwB,AACxB,qBAAuB,AACvB,4BAA8B,AAC9B,yCAA2C,AAC3C,iCAAmC,AACnC,oBAAsB,AACtB,mBAAsB,CACvB","file":"sideboxChat.vue","sourcesContent":["\n.sidebox-open {\n  overflow: hidden !important;\n}\n.chatbutton {\n  width: 66px;\n  height: 66px;\n}\n#mck-contact-search-list {\n  display: none !important;\n}\n.mck-box input {\n  line-height: inherit !important;\n}\n.mck-box input::-webkit-input-placeholder {\n  line-height: inherit !important;\n}\n.mck-box input::-moz-placeholder {\n  line-height: inherit !important;\n}\n.mck-box input::-ms-input-placeholder {\n  line-height: inherit !important;\n}\n.mck-box input::placeholder {\n  line-height: inherit !important;\n}\n.mck-sidebox.fade.in {\n  width: 100% !important;\n}\n.mck-alpha-contact-image img {\n  width: 43px !important;\n  height: 43px !important;\n}\n.row.mck-vid-overlay-footer.mck-flex-footer {\n  margin: 0 !important;\n}\n.mck-vid-scr-controls {\n  width: 100% !important;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n}\n.row.mck-vid-overlay-header {\n  padding-top: 20px !important;\n}\n.mck-vid-icon span {\n  color: #fff !important;\n}\n.mck-videocall-image {\n  width: 50px !important;\n  height: 50px !important;\n  border-radius: 100% !important;\n}\n.footer-controls {\n  width: auto !important;\n  float: none !important;\n  margin: 0 !important;\n}\n.mck-contact-list .blk-lg-8 {\n  width: calc(100% - 55px) !important;\n}\n.mck-running-on.vis {\n  display: none !important;\n}\n.mck-msg-box {\n  min-height: 0px !important;\n  font-size: 15px !important;\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  padding: 16px 14px 10px 14px !important;\n}\n.applozic-vid-container {\n  width: 100% !important;\n  padding: 0px !important;\n  max-width: none !important;\n}\n#mck-sidebox-launcher {\n  display: none !important;\n}\n.mck-sidebox-launcher {\n  display: none !important;\n}\n#mck-vid-icon {\n  color: #fff !important;\n  position: relative;\n}\n#mck-vid-icon span {\n  width: 150px;\n  display: block;\n  position: absolute;\n  left: -43px;\n}\n.mck-vid-overlay-footer {\n  margin-left: 0px !important;\n}\n.mck-vid-scr-controls .footer-controls {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n}\n.mck-vid-scr-controls .footer-controls button {\n  display: -webkit-box !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -webkit-box-align: center !important;\n      -ms-flex-align: center !important;\n          align-items: center !important;\n  -webkit-box-pack: center !important;\n      -ms-flex-pack: center !important;\n          justify-content: center !important;\n  margin: 4px !important;\n}\n#mck-microfone-mute-btn {\n  border-radius: 50%;\n  height: 56px !important;\n  width: 56px !important;\n}\n.unread {\n  position: absolute !important;\n  z-index: 99999 !important;\n  color: #fff !important;\n  font-size: 12px !important;\n  font-weight: 700 !important;\n  background: red !important;\n  top: 0px !important;\n  right: 0px !important;\n  height: 20px !important;\n  width: 20px !important;\n  border-radius: 50% !important;\n  -webkit-transform: rotate(0deg) !important;\n  transform: rotate(0deg) !important;\n  opacity: 1 !important;\n  left: auto !important;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(832);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(772)("1e24f439", content, true, {});

/***/ }),

/***/ 834:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$route.path === '/user/feed') ? _c('div', [(_vm.privileges.chat.private_chat) ? _c('v-btn', {
    staticClass: "chatbutton primary",
    attrs: {
      "fixed": "",
      "dark": "",
      "bottom": "",
      "right": "",
      "fab": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openChat.apply(null, arguments)
      }
    }
  }, [_c('v-icon', {
    staticClass: "chaticon"
  }, [_vm._v("chat")]), _vm._v(" "), (_vm.unread) ? _c('span', {
    staticClass: "unread"
  }, [_vm._v(_vm._s(_vm.unread))]) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),

/***/ 946:
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ })

});


// WEBPACK FOOTER //
// static/js/18.fbbcda65106d9748399f.js